import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'p-radio',
  templateUrl: './p-radio.component.html',
  styleUrls: ['./p-radio.component.scss'],
})
export class PRadioComponent {
  @Input() label!: string;
  @Input() checked = false;
  @Input() disabled = false;
  @Input() alwaysActivated = false;

  @Output() switched = new EventEmitter<boolean>();

  onChange(event: Event): void {
    this.switched.emit((event.target as HTMLInputElement).checked);
  }
}
